import { render, staticRenderFns } from "./EditPatent.vue?vue&type=template&id=5077b5a6"
import script from "./EditPatent.vue?vue&type=script&lang=js"
export * from "./EditPatent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports